<template>
  <div class="bimetallic-thermometer-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>长度差 → 扭力 → 指针偏转</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Dial -->
          <circle cx="200" cy="120" r="80" fill="#222" stroke="#888" stroke-width="2" />
          <g v-for="i in 12" :key="i" :transform="`rotate(${i*30}, 200, 120)`">
             <line x1="200" y1="50" x2="200" y2="60" stroke="#888" />
             <text x="200" y="45" text-anchor="middle" fill="#555" font-size="8" :transform="`rotate(${-i*30}, 200, 45)`">{{ i*10 }}</text>
          </g>

          <!-- The Bimetallic Spring (Spiral) -->
          <path :d="spiralPath" fill="none" stroke="url(#metal-grad)" stroke-width="4" />
          <defs>
             <linearGradient id="metal-grad">
                <stop offset="0%" stop-color="#ffd700" />
                <stop offset="100%" stop-color="#aaa" />
             </linearGradient>
          </defs>

          <!-- The Needle -->
          <g :transform="`rotate(${temp * 2.5 - 120}, 200, 120)`">
             <line x1="200" y1="120" x2="200" y2="60" stroke="#ff4757" stroke-width="3" />
             <circle cx="200" cy="120" r="5" fill="#ff4757" />
          </g>

          <!-- Heat Source indicator -->
          <g transform="translate(340, 200)">
             <path v-if="temp > 40" d="M -10,0 Q 0,-30 10,0 Z" fill="#ff4757" opacity="0.6">
                <animate attributeName="opacity" values="0.2;0.8;0.2" dur="0.5s" repeatCount="indefinite" />
             </path>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>测量温度: {{ temp }} °C</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>环境温度调节</label>
             <el-slider v-model="temp" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>双金属温度计将两片膨胀系数不同的金属条叠合在一起制成**螺旋弹簧**。当温度升高时，膨胀系数大的一侧伸长更多，迫使螺旋产生扭转形变。这种微小的线性物理量差被螺旋结构**机械放大**，直接带动中心指针旋转，从而在刻度盘上指示出温度。它结构坚固、无需电池，广泛用于工业管道和烤箱温控。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BimetallicThermometerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 20
    }
  },
  computed: {
    spiralPath() {
       let d = "M 200 120 ";
       let turns = 2;
       let points = 50;
       // Tightness changes with temp
       let spacing = 8 + (this.temp - 20) * 0.1; // eslint-disable-line no-unused-vars
       for (let i = 0; i <= points; i++) {
          let angle = (i / points) * Math.PI * 2 * turns;
          let r = (i / points) * 30;
          let x = 200 + r * Math.cos(angle);
          let y = 120 + r * Math.sin(angle);
          d += `L ${x} ${y} `;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
.bimetallic-thermometer-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
